export const getToken = ()=> {
    return localStorage.getItem("cat-token");
}
export const storeToken = (token)=> {
    return localStorage.setItem("cat-token", token);
}
export const deleteToken = ()=> {
    return localStorage.removeItem("cat-token");
}

export const storeLoginDetails = (loginDetails)=> {
    try{
        return localStorage.setItem("login-details", JSON.stringify(loginDetails));
    } catch(e) {

    }
}
export const getLoginDetails = ()=> {
    try {
        return JSON.parse(localStorage.getItem("login-details"));
    } catch(e) {
        return {};
    }
}

const TESTING_REPORTS_ALLOWED_EMAILS = [
    "admin@abcattech.com",
    "brad@abcattech.com",
];

export const canAccessTestingReports = (loginDetails) => {
    const details = loginDetails || getLoginDetails() || {};
    const userEmail = (details.email || details.userEmail || "").trim().toLowerCase();
    return TESTING_REPORTS_ALLOWED_EMAILS.includes(userEmail);
};

const CUSTOM_HEDGE_REPORT_ALLOWED_EMAILS = [
    "admin@abcattech.com",
    "brad@abcattech.com",
    "grader1@abcattech.com",
    "chris@abcattech.com",
];

export const canAccessCustomHedgeReport = (loginDetails) => {
    const details = loginDetails || getLoginDetails() || {};
    const userEmail = (details.email || details.userEmail || "").trim().toLowerCase();
    return CUSTOM_HEDGE_REPORT_ALLOWED_EMAILS.includes(userEmail);
};

export const canAccessHedgeLockReport = (loginDetails) => {
    return canAccessCustomHedgeReport(loginDetails);
};

const ASSAY_INSIGHTS_ALLOWED_EMAILS = [
    "admin@abcattech.com",
    "brad@abcattech.com",
    "grader1@abcattech.com",
];

export const canAccessAssayInsights = (loginDetails) => {
    const details = loginDetails || getLoginDetails() || {};
    const userEmail = (details.email || details.userEmail || "").trim().toLowerCase();
    return ASSAY_INSIGHTS_ALLOWED_EMAILS.includes(userEmail);
};

const HEDGE_ALLOWED_EMAILS = [
    "admin@abcattech.com",
    "brad@abcattech.com",
];

/** Lot Settlement, CXO Settlement, Underpayment Leak — admin + brad only. */
const SETTLEMENT_INSIGHTS_ALLOWED_EMAILS = [
    "admin@abcattech.com",
    "brad@abcattech.com",
];

export const canAccessHedgePlanning = (loginDetails) => {
    const details = loginDetails || getLoginDetails() || {};
    const userEmail = (details.email || details.userEmail || "").trim().toLowerCase();
    return HEDGE_ALLOWED_EMAILS.includes(userEmail);
};

export const canAccessSettlementInsights = (loginDetails) => {
    const details = loginDetails || getLoginDetails() || {};
    const userEmail = (details.email || details.userEmail || "").trim().toLowerCase();
    return SETTLEMENT_INSIGHTS_ALLOWED_EMAILS.includes(userEmail);
};

export const canAccessHedgeManagement = (loginDetails) => {
    return canAccessHedgePlanning(loginDetails);
};

export const canAccessBuyerLocationInsights = (loginDetails) => {
    return canAccessHedgePlanning(loginDetails);
};

export const canAccessBuyingInsights = (loginDetails) => {
    return canAccessHedgePlanning(loginDetails);
};

/** Login sets "1"; PageLayout upgrades to "open" while modal is shown; removed when user closes. */
export const SESSION_PROMPT_APP_DOWNLOAD_AFTER_LOGIN =
  "ab-cattech-show-app-download-on-load";